<template>
  <div>
    <v-row>
      <v-col cols="12" class="py-0">
        <gg-card-title>
          Cancellation Request #{{ cancellation.id }}
        </gg-card-title>
      </v-col>
      <v-col cols="12">
        <router-link :to="{ name: 'billing' }">← Back to Billing</router-link>
      </v-col>
      <v-col cols="12" sm="6">
        <gg-loading :loading="loading" class="fill-height">
          <div class="fill-height">
            <cancellation-data
              v-if="!loading"
              :details="cancellation"
              @cancel-now="cancelNow"
              @autorenew-now="autorenewConfirmModal = true"
            />
          </div>
        </gg-loading>
      </v-col>
      <v-col cols="12" sm="6">
        <gg-loading :loading="loading" class="fill-height">
          <div class="fill-height">
            <reply
              v-if="!loading"
              @post-added="getData"
            />
          </div>
        </gg-loading>
      </v-col>
      <v-col cols="12">
        <gg-loading :loading="loading" class="fill-height">
          <div class="fill-height">
            <cancellation-services
              v-if="!loading"
              :cr_services="cancellation.services"
            />
          </div>
        </gg-loading>
      </v-col>
      <v-col cols="12">
        <gg-loading :loading="loading">
          <div>
            <posts
              v-if="!loading"
              :posts="cancellation.replies"
            />
          </div>
        </gg-loading>
      </v-col>
    </v-row>
    <gg-modal :is-active="modalCancel" @close="closeCancelModal">
      <template v-slot:toolbar>
        Cancel Now
      </template>
      <template v-slot:body>
        <p>You are indicating you want to cancel your service now instead of waiting until the due date.</p>
        <p>Proceeding will immediately delete the selected service and any associated records.</p>
        <p>Are you sure you want to proceed?</p>
      </template>
      <template v-slot:actions>
        <gg-btn secondary @click="closeCancelModal">
          No
        </gg-btn>
        <gg-btn primary @click="proceedCancelNow" :loading="modalLoading">
          Yes
        </gg-btn>
      </template>
    </gg-modal>
    <autorenew-enable
      v-if="autorenewConfirmModal"
      @close="autorenewCloseModal"
      :cr-id="crId"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CancellationData from 'Components/Cancellations/CancellationData'
import Reply from 'Components/Cancellations/Reply'
import Posts from 'Components/Cancellations/Posts'
import CancellationServices from 'Components/Cancellations/CancellationServices'
import AutorenewEnable from 'Components/Modals/AutorenewEnable'

export default {
  name: 'CancellationDetailView',
  components: {
    CancellationData,
    Reply,
    Posts,
    CancellationServices,
    AutorenewEnable,
  },
  data: () => ({
    loading: false,
    modalCancel: false,
    modalLoading: false,
    crId: false,
    autorenewModalConfirmOpen: false,
    autorenewLoading: false,
    autorenewConfirmModal: false,
  }),
  async created () {
    this.loading = true
    this.crId = this.$route.params.id
    await this.getData()
    this.loading = false
  },
  computed: {
    ...mapGetters(['cancellation', 'services'])
  },
  methods: {
    ...mapActions(['getCancellation', 'reportError', 'sendCrExpedite', 'enableAutorenew']),
    async getData () {
      try {
        await this.getCancellation(this.crId)
      } catch (e) {
        await this.$router.push({ name: 'dashboard' })
        this.reportError(e)
      }
    },
    cancelNow () {
      this.modalCancel = true
    },
    closeCancelModal () {
      this.modalCancel = false
    },
    async proceedCancelNow () {
      this.modalLoading = true
      try {
        await this.sendCrExpedite({ cr_id: this.crId })
      } catch (e) {
        this.reportError(e)
      } finally {
        await this.getData()
        this.modalLoading = false
        this.modalCancel = false
      }
    },
    async acceptModalAutorenewConfirm () {
      if (!this.serviceId || !this.serviceType) {
        console.error('Auto-renew failed due to missing parameters:', { serviceId: this.serviceId, serviceType: this.serviceType })
        return
      }

      this.autorenewLoading = true
      try {
        await this.callEnableAutorenew()
      } finally {
        this.autorenewLoading = false
        this.closeModalAutorenewConfirm()
      }
    },
    async callEnableAutorenew () {
      if (!this.serviceId || !this.serviceType) {
        console.error('Auto-renew failed due to missing parameters:', { serviceId: this.serviceId, serviceType: this.serviceType })
        return
      }

      if (!this.cr_open.id) {
        console.error('Missing cancellation_id (cr_open.id)')
        return
      }
      try {
        await this.enableAutorenew({ service_id: this.serviceId, service_type: this.serviceType, cancellation_id: this.cr_open.id })
        this.$router.push({ path: `/cancellations/${this.cr_open.id}` })
      } catch (error) {
        console.error(`Error enabling auto-renew for service ${this.serviceId} (type: ${this.serviceType}):`, error)
      }
    },
    autorenewConfirmModalOpen () {
      this.autorenewModalConfirmOpen = true
    },
    closeModalAutorenewConfirm () {
      this.autorenewModalConfirmOpen = false
    },
    async autorenewCloseModal () {
      await this.getData()
      this.autorenewConfirmModal = false
    },
  }
}
</script>
